// extracted by mini-css-extract-plugin
module.exports = {"item":"_15509","cover":"_879","content":"_6557","main":"_11953","name":"_15790","info":"_18524","price":"_17794","sales":"_13290","extra":"_19292"};